import { useEffect } from "react";
import styles from "./EnvironmentList.module.scss";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/store";
import { getEnvironments } from "../../../../../../redux/reducers/ui/uiSelectors";
import { EnvironmentService } from "../../../../../../services/EnvironmentService";
import { LoaderWithoutText } from "../../../../../../shared/LoaderWithoutText/LoaderWithoutText";
import { getIsShowInnerLoader } from "../../../../../../redux/reducers/app/appSelectors";
import { IStudioStage } from "../../../../../../redux/reducers/ui/uiTypes";
import { EnvironmentListItem } from "../EnvironmentListItem/EnvironmentListItem";

export const EnvironmentList = () => {
  const dispatch = useAppDispatch();
  const { isShowEnvironmentLoader } = useAppSelector(getIsShowInnerLoader());
  const environments = useAppSelector(getEnvironments());

  useEffect(() => {
    if (environments && !environments.length) {
      EnvironmentService.fetchEnvironments(dispatch);
    }
  }, [environments]);

  if (isShowEnvironmentLoader) {
    return <LoaderWithoutText />;
  }

  return (
    <>
      {environments && environments.length ? (
        <div className={styles.wrapper}>
          {environments?.map((env: IStudioStage, index: number) => {
            const { id, name } = env;
            return (
              <EnvironmentListItem
                key={`${id}-${name}`}
                item={env}
                index={index}
              />
            );
          })}
        </div>
      ) : (
        <p className="empty-message">/// No environments ///</p>
      )}
    </>
  );
};
